import AccessFooter from "./AccessFooter";

export default AccessFooter;
